import { useMemo, useState } from "react";
import Link from "admin/shared/ui/Link.Component";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";

import { accountingConnector } from "../../../../services/accounting/connector";
import TableNew, { CELL_TYPES } from "../../../../shared/Table";
import { compose } from "redux";
import amlConnector from "../../../../services/aml/amlConnector";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";

const NonTransferableDepositsContent = ({
  accounting,
  itemsToExclude,
  changeInvestorDepositOcr,
  sendBackDeposit,
}) => {
  const dataNonTransferable = useMemo(() => {
    return [...accounting.investorDepositsToTransfer.dataNonTransferable].sort(
      (a, b) => {
        return (
          new Date(b.Modified ?? b.Created) - new Date(a.Modified ?? a.Created)
        );
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    accounting.investorDepositsToTransfer.dataNonTransferable,
    accounting,
    itemsToExclude,
  ]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(getColumns, []);

  return (
    <div className="content-padding">
      <Card>
        <CardContent>
          <CardHeader title={"Non transferable deposits"} />
          <TableNew
            columns={columns}
            items={dataNonTransferable}
            actionColumnWidth={220}
            tableKey="non_transferable_deposits"
          />
        </CardContent>
      </Card>
    </div>
  );

  function getColumns() {
    return [
      {
        key: "Created",
        label: "Created",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "Modified",
        label: "Modified",
        visible: false,
        type: CELL_TYPES.date,
      },
      {
        key: "CanBeTransferredMessage",
        label: "Reason",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "InvestorId",
        label: "InvestorId",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return (
            <Link toState={"userOverview"} parameters={["identity", value]}>
              {value}
            </Link>
          );
        },
      },
      {
        key: "UniqueRef",
        label: "PaymentId",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "DepositOcr", label: "OCR", visible: true, type: CELL_TYPES.text },
      { key: "Amount", label: "Amount", visible: true, type: CELL_TYPES.text },
      {
        key: "Currency",
        label: "Currency",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "DepotId",
        label: "DepotId",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Id",
        label: "Actions",
        visible: true,
        renderer: (value, item) => {
          return (
            <NonTransferableDepositsActions
              item={item}
              changeOcr={changeInvestorDepositOcr}
              sendBack={sendBackDeposit}
            />
          );
        },
      },
    ];
  }
};

const NonTransferableDepositsActions = ({ item, changeOcr, sendBack }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [sendBackDialogOpen, setSendBackDialogOpen] = useState(false);
  const [newOcr, setNewOcr] = useState(item.DepositOcr);
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");

  return (
    <div className="table-cell-actions">
      <Button
        variant="contained"
        color="primary"
        onClick={() => setDialogOpen(true)}
      >
        Change OCR
      </Button>{" "}
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => setSendBackDialogOpen(true)}
      >
        Send back
      </Button>
      {/* Dialogs */}
      <Dialog
        title="Change OCR"
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      >
        <DialogContent>
          <TextField
            label="New OCR"
            value={newOcr}
            onChange={(e) => setNewOcr(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            id="changeOcrConfirm"
            variant="outlined"
            color="primary"
            onClick={handleConfirm}
          >
            Confirm
          </Button>
          <Button variant="outlined" onClick={() => setDialogOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        title="Send back"
        open={sendBackDialogOpen}
        onClose={() => setSendBackDialogOpen(false)}
      >
        <DialogContent>
          <TextField
            label="Bank account number"
            value={bankAccountNumber}
            onChange={(e) => setBankAccountNumber(e.target.value)}
          />
          <br />
          <TextField
            label="Bank account name"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            id="sendBackDeposit"
            variant="outlined"
            color="primary"
            onClick={handleSendBack}
          >
            Send
          </Button>
          <Button
            variant="outlined"
            onClick={() => setSendBackDialogOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

  function handleConfirm() {
    changeOcr(item.InvestorDepositId, newOcr);
    setDialogOpen(false);
  }

  function handleSendBack() {
    sendBack(item.InvestorDepositId, bankAccountNumber, bankName);
    setSendBackDialogOpen(false);
  }
};

export default compose(
  amlConnector,
  accountingConnector,
)(NonTransferableDepositsContent);
